import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ServiceItem } from 'orderme-api-integration-client';
import { roundDoubleNumbers } from '../../helpers/currency';
import FriendsBadge from './friendsBadge';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import InfoIcon from '@mui/icons-material/Info';
import { getServicePrice } from '../../helpers/costCounter';
import { ProductPrices } from './productPrices';

interface CartProductPriceProps {
  item: ServiceItem;
  serviceCount: number;
  isSmallFont?: boolean;
}

export function CartProductPrice({ item, serviceCount, isSmallFont }: CartProductPriceProps) {
  const [isPricesVisible, setIsPricesVisible] = useState(false);
  const { t } = useTranslation();
  const isLoggedIn = useAppSelector((state: RootState) => state.authState.isLoggedIn);
  const servicePrice: number = getServicePrice(item, serviceCount);
  const hasAmountPrice = item.prices?.length > 1;
  const isPriceForLoggedInUser = item.originalPrice > servicePrice;
  const showFriendsPrice = !isLoggedIn && isPriceForLoggedInUser;

  const togglePricesVisible = () => {
    setIsPricesVisible(!isPricesVisible);
  };

  return (
    <Grid container direction="column">
      {
        <Grid container sx={{ justifyContent: 'flex-end' }}>
          {showFriendsPrice && isSmallFont && (
            <Box sx={{ mr: '10px' }}>
              <FriendsBadge price={servicePrice} isSmallFont={isSmallFont} />
            </Box>
          )}
          <Grid
            sx={{
              fontWeight: showFriendsPrice ? '600' : null,
              opacity: !showFriendsPrice ? 0.7 : null,
              color: 'black',
              fontSize: isSmallFont ? '14px' : '19px',
              textDecoration: !showFriendsPrice ? 'line-through' : null,
              pr: '15px',
              display: item.originalPrice - servicePrice === 0 ? 'none' : 'inline-block',
            }}
          >
            {roundDoubleNumbers(item.originalPrice)} €
          </Grid>
          {!showFriendsPrice && (
            <Grid sx={{ pr: '15px', fontWeight: '600', fontSize: isSmallFont ? '14px' : '19px' }}>
              {roundDoubleNumbers(servicePrice)} €
            </Grid>
          )}
        </Grid>
      }
      {showFriendsPrice && !isSmallFont && (
        <Grid container sx={{ pr: '10px', justifyContent: 'flex-end', alignItems: 'center' }}>
          <FriendsBadge price={servicePrice} isSmallFont={isSmallFont} />
        </Grid>
      )}
      {hasAmountPrice && (
        <Grid
          container
          direction="row"
          sx={{
            backgroundColor: 'white',
            pr: '10px',
            pt: '5px',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
          onClick={togglePricesVisible}
        >
          <Typography alignItems="right" sx={{ fontSize: isSmallFont ? '12px' : '14px' }}>
            {t('services:bulkDiscount')}
          </Typography>
          <InfoIcon fontSize="small" sx={{ color: 'infoIcon' }} />
        </Grid>
      )}
      {hasAmountPrice && (
        <ProductPrices
          serviceName={item.name}
          prices={item.prices}
          open={isPricesVisible}
          onClose={togglePricesVisible}
        />
      )}
    </Grid>
  );
}
